import { z } from "zod";
import { APIGame } from "@rosette/ts/src/business/api/api_schema.js";
import { fetchWithThrow } from "@rosette/web_utils/src/fetchWithThrow.js";


export const GetGameRequest = z.object({
    publicID: z.string(),
});
export type GetGameRequest = z.infer<typeof GetGameRequest>;


export const GetGameResponse = z.object({
    game: z.nullable(APIGame),
});
export type GetGameResponse = z.infer<typeof GetGameResponse>;


export async function getGame(publicID: string | null): Promise<GetGameResponse> {
    if (publicID === null)
        return { game: null };

    const request: GetGameRequest = { publicID };
    const response = await fetchWithThrow("/api/getGame", {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
    return GetGameResponse.parse(await response.json());
}
